import React from "react";

export default function AppleSVG() {
  return (
    <svg
      role="img"
      width="32"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 32"
      className="icon icon-apple"
    >
      <title>Apple</title>
      <path
        fill="currentcolor"
        d="M 19.917969 16.792969 C 19.90625 14.5 20.945312 12.769531 23.042969 11.492188 C 21.867188 9.8125 20.09375 8.886719 17.75 8.707031 C 15.53125 8.53125 13.105469 10 12.21875 10 C 11.28125 10 9.132812 8.769531 7.445312 8.769531 C 3.957031 8.824219 0.25 11.550781 0.25 17.09375 C 0.25 18.730469 0.550781 20.421875 1.148438 22.167969 C 1.949219 24.460938 4.835938 30.085938 7.851562 29.992188 C 9.425781 29.957031 10.539062 28.875 12.585938 28.875 C 14.574219 28.875 15.605469 29.992188 17.363281 29.992188 C 20.398438 29.949219 23.011719 24.835938 23.773438 22.539062 C 19.699219 20.617188 19.917969 16.914062 19.917969 16.792969 Z M 16.382812 6.53125 C 18.085938 4.507812 17.929688 2.664062 17.882812 2 C 16.375 2.085938 14.632812 3.023438 13.636719 4.179688 C 12.542969 5.417969 11.898438 6.949219 12.039062 8.675781 C 13.667969 8.800781 15.15625 7.960938 16.382812 6.53125 Z M 16.382812 6.53125 "
      ></path>
    </svg>
  );
}
